// src/services/BackendServices.tsx

import axios from "axios";
import { URL, URL_SECURITY } from "../utils/config";
import GeneralServices from "./GeneralServices";
import SecurityServices from "./SecurityServices";
import store from "../store";

// Instancia para seguridad
const securityInstance = axios.create({
  baseURL: URL_SECURITY,
  headers: {
    "Strict-Transport-Security": "max-age=31536000; includeSubDomains; preload",
    "Content-Security-Policy":
      "default-src 'self'; script-src 'self'; style-src 'self'; img-src 'self' data:; font-src 'self'; connect-src 'self'; frame-ancestors 'none';",
    "X-Frame-Options": "DENY",
    "X-Content-Type-Options": "nosniff",
    "Referrer-Policy": "no-referrer",
    "Permissions-Policy":
      "geolocation=(), microphone=(), camera=(), vibrate=()",
  },
});

// Instancia para el resto de las funciones
const generalInstance = axios.create({
  baseURL: URL,
  headers: {
    "Strict-Transport-Security": "max-age=31536000; includeSubDomains; preload",
    "Content-Security-Policy":
      "default-src 'self'; script-src 'self'; style-src 'self'; img-src 'self' data:; font-src 'self'; connect-src 'self'; frame-ancestors 'none';",
    "X-Frame-Options": "DENY",
    "X-Content-Type-Options": "nosniff",
    "Referrer-Policy": "no-referrer",
    "Permissions-Policy":
      "geolocation=(), microphone=(), camera=(), vibrate=()",
  },
});

// **Interceptor para agregar el token en los headers de cada solicitud**
const attachToken = (config: any) => {
  const state = store.getState();
  const token = state?.userProfile?.expressToken;

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
};

// **Agregar el interceptor de solicitud a ambas instancias**
generalInstance.interceptors.request.use(attachToken, (error) =>
  Promise.reject(error)
);
securityInstance.interceptors.request.use(attachToken, (error) =>
  Promise.reject(error)
);

// **Interceptor de respuesta para manejar errores (Redirigir en 403)**
const handleResponseError = (error: any) => {
  if (error.response?.status === 403) {
    window.location.href = window.location.origin + "/"; // Redirigir si es 403
  }
  return Promise.reject(error);
};

// **Aplicar el interceptor de respuesta a ambas instancias**
generalInstance.interceptors.response.use(
  (response) => response,
  handleResponseError
);
securityInstance.interceptors.response.use(
  (response) => response,
  handleResponseError
);

// **API exportada para su uso en la aplicación**
const api = {
  SecurityServices: SecurityServices(securityInstance),
  GeneralServices: GeneralServices(generalInstance),
};

export default api;
